import { rootService } from 'api/api-root'
import { apiResponse } from 'api/api-response'
import { recordError } from 'tracing'
import _ from 'lodash'

export const apiGet = async ({ token, data, url, onLogout = () => {}, signal = undefined }) => {
  let headers
  let obj = apiResponse()

  if (token) {
    headers = {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  } else {
    headers = {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  }

  try {
    const res = signal
      ? await rootService.get(`/${url}`, {
          headers,
          responseType: 'json',
          params: data,
          signal
        })
      : await rootService.get(`/${url}`, {
          headers,
          responseType: 'json',
          params: data
        })
    obj.resData = res?.data
    obj.resStatus = res?.status
    return obj
  } catch (error) {
    if (error?.response?.status === 401) {
      _.throttle(() => {
        onLogout()
      }, 3000)()
    }
    recordError(error, { 'http.operation': 'AXIOS GET' })
    obj.resData = error?.response?.data
    obj.resStatus = error?.response?.status
    return obj
  }
}
